import React, { useState } from "react";
import { Badge } from "reactstrap";
import { DataTable, DataTableBody, DataTableHead, DataTableItem, DataTableRow } from "../../../components/Component";
import moment from "moment";
import { RotaType } from "./RotaList";
import RotaDetailModal, { ModalStatus } from "./RotaDetailModal";
import { convertHexToColor } from "../../../utils/Functions";
import RotaEstimateModel from "./RotaEstimateModel";
import { HourBadge } from "../../../components/badge/StatusBadge";
const RotaMatrix = ({ isLoading, hList, vList, rotaType, onCancel, totalRotaHours, clientdata, isSwitchOn }) => {
  const [detailModal, setDetailModal] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [estimateModal, setEstimateModal] = useState(false);
  function handleShowDetail(detail) {
    setDetailModal(true);
    setSelectedData(detail);
  }
  vList = vList.sort((a, b) => moment(a.startTime) - moment(b.startTime));
  return (
    <>
      <div className="matrix-table h-100">
        {vList?.length > 0 && !isSwitchOn && (
          <div className="flex justify-end mb-2">
            {totalRotaHours?.actualHours > 0 && (
              <span onClick={() => setEstimateModal(true)} className="text-primary cursor-pointer me-2">
                <HourBadge color={"primary"} text={`Actual hours: ${totalRotaHours?.actualHours?.toFixed(2)}`} />
              </span>
            )}

            {totalRotaHours?.estimateHours > 0 && (
              <span onClick={() => setEstimateModal(true)} className="text-success cursor-pointer">
                <HourBadge color={"success"} text={`Estimates hours: ${totalRotaHours?.estimateHours?.toFixed(2)}`} />
              </span>
            )}
          </div>
        )}
        <DataTable
          id="style-3"
          className="h-100 card-stretch overflow-auto min-h-calc_100vh_-_220  border border-light-gray w-100 border mx-10"
        >
          <DataTableBody>
            <DataTableHead>
              {/* Render dates for the rest of the indices */}
              {hList?.map((item, index) => (
                <DataTableRow key={index} className="border-light-gray-right text-center px-2 border-bottom">
                  <span className="matrix-font-day">{moment(item).format("ddd")}</span>
                  <span className="sub-text matrix-font-date">{moment(item).format("DD/MM")}</span>
                </DataTableRow>
              ))}
            </DataTableHead>
            <DataTableItem className="t-body matrix-card-align-top">
              {vList?.length > 0 &&
                hList.map((hItem, hIndex) => {
                  let rotas = vList.filter((item) =>
                    item.rotaDate
                      ? moment(item.rotaDate).format("YYYY-MM-DD") === moment(hItem).format("YYYY-MM-DD")
                      : moment(item.startDate).format("YYYY-MM-DD") === moment(hItem).format("YYYY-MM-DD"),
                  );
                  return (
                    <DataTableRow key={hIndex} className="border-light-gray-right text-black text-center px-2">
                      {rotas?.map((vItem, index) => {
                        let color = `outline-${convertHexToColor(vItem?.grade?.colourHex ?? "#ff63a5") ?? ""}`;
                        return (
                          <React.Fragment key={index}>
                            <Badge
                              onClick={() => handleShowDetail(vItem)}
                              color={color}
                              className={`badge-dim badge-sm matrix-text-card cursor-pointer w-100`}
                            >
                              <div className={`d-flex`}>
                                <span
                                  style={{
                                    borderLeft: `4px solid ${vItem?.grade?.colourHex ?? "#ff63a5"}`,
                                    marginRight: "10px",
                                    borderRadius: "10px",
                                  }}
                                ></span>
                                <span className="text-dark">
                                  {rotaType === RotaType.carer
                                    ? vItem?.client?.name
                                      ? vItem?.client?.name
                                      : vItem?.title
                                    : vItem?.carer}
                                  <br />
                                  {vItem?.shiftType?.value && (
                                    <img
                                      alt="#"
                                      src={
                                        vItem?.shiftType?.value === "DAY"
                                          ? require("../../../assets/images/jsTree/shiftIcon/Sun.png")
                                          : require("../../../assets/images/jsTree/shiftIcon/Moon.png")
                                      }
                                      style={{
                                        width: "12px",
                                        height: "12px",
                                      }}
                                      className="me-1"
                                    />
                                  )}
                                  {moment(vItem?.startTime).format("HH:mm")} - {moment(vItem?.endTime).format("HH:mm")}
                                </span>
                              </div>
                            </Badge>
                          </React.Fragment>
                        );
                      })}
                    </DataTableRow>
                  );
                })}
            </DataTableItem>
          </DataTableBody>
          {vList?.length === 0 && (
            <span className="d-flex justify-content-center border-bottom">There is no data found</span>
          )}
        </DataTable>
      </div>
      <RotaDetailModal
        visible={detailModal}
        item={selectedData}
        onClosed={(status) => {
          if (status === ModalStatus.success) {
            onCancel();
          }
          setDetailModal(false);
        }}
      />
      <RotaEstimateModel visible={estimateModal} onClosed={(status) => setEstimateModal(false)} item={clientdata} />
    </>
  );
};
export default RotaMatrix;
